<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div v-show="show"
                                     class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <span v-for="(err, index) in validation_errors" :key="index">
                                      {{ err[0] }} <br/>
                                    </span>
                                </div>
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="old_password">Old Password <span class="c-required">*</span></label>
                                            <input type="password" v-model="pass.old_password" v-validate="{ required: true }" id="old_password" name="old_password" placeholder="Old Password" class="form-control form-control-sm"/>
                                            <div class="invalid-feedback">Please Enter Old Password</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="password">Password <span class="c-required">*</span></label>
                                            <input type="password" v-model="pass.password" v-validate="{ required: true }" id="password" name="password" placeholder="Password" class="form-control form-control-sm"/>
                                            <div class="invalid-feedback">Please Enter New Password</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="password_confirmation">Confirm Password <span class="c-required">*</span></label>
                                            <input type="password" v-model="pass.password_confirmation" v-validate="{ required: true }" id="password_confirmation" name="password_confirmation" placeholder="Confirm Password" class="form-control form-control-sm"/>
                                            <div class="invalid-feedback">Please Enter Confirm Password</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <button class="btn btn-success waves-effect waves-light mr-2" @click.prevent="update">Update</button>
                                            <a href="/user/profile" class="btn btn-danger waves-effect waves-light">Back</a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Update password",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Update password",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Password',
                        active: true,
                    },
                ],
                validation_errors: {},
                pass: {},
                show: false,
            };
        },

        methods: {
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/profile/password/update", this.pass)
                            .then(response => {
                                if (!response.data.error) {
                                    if (response.data.error){
                                        this.$bvToast.toast(response.data.message, {
                                            title: "Error",
                                            autoHideDelay: 5000,
                                            variant: "danger"
                                        });
                                    }else{
                                        this.$bvToast.toast(response.data.message, {
                                            title: "Success",
                                            autoHideDelay: 5000,
                                            variant: "success"
                                        });
                                        this.pass = "";
                                        this.$router.push("/user/profile");
                                    }

                                } else {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            }
        },

        mounted() {

        }
    };
</script>